import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, allowedRoles }) => {    
    const userInfo = useSelector((state) => state.user.userInfo);       
    
    if (!userInfo || userInfo.Authenticated === false) {        
        return <Navigate to="/" replace />;
    }   
    
    // Si se especifican roles permitidos, verificar el rol del usuario
    // Si se especifican roles permitidos, verificar el rol del usuario
    // Si se especifican roles permitidos, verificar el rol del usuario
if (allowedRoles && allowedRoles.length > 0) {

    const rawRoles =
        userInfo?.roles ??
        userInfo?.Roles ??
        userInfo?.rol ??
        userInfo?.role ??
        userInfo?.Rol;

    let rolesArray = [];

    if (Array.isArray(rawRoles)) {
        rolesArray = rawRoles;

    } else if (typeof rawRoles === 'string') {

        rolesArray = rawRoles
            .split(',')
            .map(r => r.trim());

    } else {
        rolesArray = [];
    }

    const hasAllowedRole = rolesArray.some(role =>
        allowedRoles.includes(role)
    );

    if (!hasAllowedRole) {
        return <Navigate to="/backoffice" replace />;
    }
}
   
    return children;
};

export default ProtectedRoute;
